import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getConsolidationDataByType } from '@/features/dashboard/api/getConsolidationDataByType.ts';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';

type QueryFnType = typeof getConsolidationDataByType;

function useConsolidationFrequency(year?: number) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-frequency', year],
    queryFn: () => getConsolidationDataByType(TypesConsolidationData.SCORE_FREQUENCIA_ALUNOS, year ? String(year) : undefined),
  });
}

export { useConsolidationFrequency };
